import * as React from "react"

import { cn } from "@/lib/utils"

/**
 * Input - Glass Greenhouse Design System
 * 
 * Changes from default Shadcn:
 * - Rounded-xl (softer corners)
 * - Taller height (h-11) for better touch targets
 * - Stone-50 background tint
 * - Focus: white bg + green ring
 * - Smooth transitions
 */
/**
 * The field styling, exported so a field this component does not render itself
 * can still look identical. The Places seam owns its own input element, so it
 * needs the class list rather than the component.
 */
export const INPUT_CLASS_NAME = cn(
  "flex h-11 w-full rounded-xl border border-stone-200 bg-stone-50/50 px-4 py-2 text-base shadow-soft-sm transition-all duration-200",
  "file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground",
  "placeholder:text-muted-foreground",
  "focus-visible:outline-none focus-visible:bg-white focus-visible:ring-2 focus-visible:ring-primary/20 focus-visible:border-primary/50",
  "disabled:cursor-not-allowed disabled:opacity-50",
  "md:text-sm",
);

const Input = React.forwardRef(({ className, type, ...props }, ref) => {
  return (
    <input
      type={type}
      className={cn(INPUT_CLASS_NAME, className)}
      ref={ref}
      {...props} />
  );
})
Input.displayName = "Input"

export { Input }
